export interface IGridState {
  [T: string]: IGridData;
}
export interface IGridData {
  skipRows: number;
  searchCriteria: any | undefined;
  systemIdentifier: string | number | undefined;
}

export const gridInitialState: IGridState = {};
